import {ConnectionType, Location} from '@flowmaps-com/flowmaps-typescriptmodels';

export function hasFullElectricConflictingConnections(location?: Location): boolean {
    return (location?.connections || []).some(connection => [
        ConnectionType.Gas, ConnectionType.Heat, ConnectionType.Cooling
    ].includes(connection.info?.connectionType as ConnectionType));
}
